// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/footer-bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* Background image */
    background-size: cover;
    background-position: center;
    padding: 20px 40px 60px 40px;
    color: #fff;
  }
  
  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    position: relative;
    z-index: 10;
  }
  
  .footer-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0vh 8%;
  }
  
  .footer-left .logo {
    max-width: 15rem;
    margin-bottom: -15px;
    margin-top: 15px;
  }
  
  .footer-left p {
    font-size: 14px;
  }
  
  .footer-right {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0vh 9%;
  }
  
  .footer-right .quadchain-text {
    max-width: 160px;
    margin: -8px;

  }
  
  .footer-links {
    display: flex;
    gap: 40px;
    flex-wrap: wrap;
  }
  
  .footer-links a {
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    display: block;
    margin-bottom: 5px;
  }
  
  .footer-links a:hover {
    text-decoration: underline;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .footer-content {
      flex-direction: column;
      align-items: center;
      gap: 3rem;

    }
  
    .footer-right {
      align-items: center;
    }
  
    .footer-links {
      /* flex-direction: column; */
      align-items: center;
      gap: 20px;
    }
  }
  .footer-submsg {
    font-family: "Roboto";
    color: rgba(255, 255, 255, 1);
    font-size: 15px;
    font-weight: 400;
    z-index: 10;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/css/footer.css"],"names":[],"mappings":"AAAA;IACI,yDAAgD,EAAE,qBAAqB;IACvE,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;EACb;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;;EAEd;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,sBAAsB;EACtB;IACE;MACE,sBAAsB;MACtB,mBAAmB;MACnB,SAAS;;IAEX;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,4BAA4B;MAC5B,mBAAmB;MACnB,SAAS;IACX;EACF;EACA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB","sourcesContent":[".footer-container {\n    background-image: url('../Images/footer-bg.svg'); /* Background image */\n    background-size: cover;\n    background-position: center;\n    padding: 20px 40px 60px 40px;\n    color: #fff;\n  }\n  \n  .footer-content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    position: relative;\n    z-index: 10;\n  }\n  \n  .footer-left {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding: 0vh 8%;\n  }\n  \n  .footer-left .logo {\n    max-width: 15rem;\n    margin-bottom: -15px;\n    margin-top: 15px;\n  }\n  \n  .footer-left p {\n    font-size: 14px;\n  }\n  \n  .footer-right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0vh 9%;\n  }\n  \n  .footer-right .quadchain-text {\n    max-width: 160px;\n    margin: -8px;\n\n  }\n  \n  .footer-links {\n    display: flex;\n    gap: 40px;\n    flex-wrap: wrap;\n  }\n  \n  .footer-links a {\n    color: #fff;\n    text-decoration: none;\n    font-size: 14px;\n    display: block;\n    margin-bottom: 5px;\n  }\n  \n  .footer-links a:hover {\n    text-decoration: underline;\n  }\n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .footer-content {\n      flex-direction: column;\n      align-items: center;\n      gap: 3rem;\n\n    }\n  \n    .footer-right {\n      align-items: center;\n    }\n  \n    .footer-links {\n      /* flex-direction: column; */\n      align-items: center;\n      gap: 20px;\n    }\n  }\n  .footer-submsg {\n    font-family: \"Roboto\";\n    color: rgba(255, 255, 255, 1);\n    font-size: 15px;\n    font-weight: 400;\n    z-index: 10;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
